var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrustIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4826_5164)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4826_5164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5628 9.5293H12.7028C11.0073 9.5293 9.63281 10.9038 9.63281 12.5993V45.4593C9.63281 47.1548 11.0073 48.5293 12.7028 48.5293H48.5628C50.2583 48.5293 51.6328 47.1548 51.6328 45.4593V12.5993C51.6328 10.9038 50.2583 9.5293 48.5628 9.5293Z",
    fill: "url(#paint0_linear_4826_5164)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.5628 9.5293H12.7028C11.0028 9.5293 9.63281 10.8993 9.63281 12.5993V15.5293H51.6328V12.5993C51.6328 10.9093 50.2628 9.5293 48.5628 9.5293Z",
    fill: "url(#paint1_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9429 13.2588C15.3461 13.2588 15.6729 12.932 15.6729 12.5288C15.6729 12.1257 15.3461 11.7988 14.9429 11.7988C14.5397 11.7988 14.2129 12.1257 14.2129 12.5288C14.2129 12.932 14.5397 13.2588 14.9429 13.2588Z",
    fill: "url(#paint2_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6343 13.2588C19.0375 13.2588 19.3643 12.932 19.3643 12.5288C19.3643 12.1257 19.0375 11.7988 18.6343 11.7988C18.2311 11.7988 17.9043 12.1257 17.9043 12.5288C17.9043 12.932 18.2311 13.2588 18.6343 13.2588Z",
    fill: "url(#paint3_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3237 13.2588C22.7269 13.2588 23.0537 12.932 23.0537 12.5288C23.0537 12.1257 22.7269 11.7988 22.3237 11.7988C21.9206 11.7988 21.5938 12.1257 21.5938 12.5288C21.5938 12.932 21.9206 13.2588 22.3237 13.2588Z",
    fill: "url(#paint4_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1309 30.5293H20.1309V48.5293H41.1309V30.5293Z",
    fill: "url(#paint5_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5628 20.3092C33.3128 19.8692 32.1828 19.3192 31.2028 18.6992C30.8528 18.4792 30.4128 18.4792 30.0628 18.6992C29.0828 19.3192 27.9428 19.8692 26.7028 20.3092C24.7728 20.9892 22.8828 21.2792 21.2528 21.2292C20.6428 21.2092 20.1328 21.6892 20.1328 22.2992V35.5992C20.1328 37.3192 21.0528 38.9192 22.5428 39.7792L29.1828 43.6092C30.0828 44.1292 31.1828 44.1292 32.0828 43.6092L38.7228 39.7792C40.2128 38.9192 41.1328 37.3192 41.1328 35.5992V22.2992C41.1328 21.6892 40.6228 21.2092 40.0128 21.2292C38.3828 21.2792 36.4928 20.9892 34.5628 20.3092Z",
    fill: "url(#paint6_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0227 21.2292C38.3927 21.2792 36.4927 20.9892 34.5627 20.3092C33.3127 19.8692 32.1827 19.3192 31.2027 18.6992C30.8527 18.4792 30.4127 18.4792 30.0627 18.6992C29.0827 19.3192 27.9427 19.8792 26.7027 20.3092C24.7727 20.9892 22.8827 21.2792 21.2527 21.2292C20.9827 21.2292 20.7427 21.3192 20.5527 21.4692L26.7327 21.8692C28.8827 22.0092 30.5527 23.7892 30.5527 25.9492V43.9892C31.0827 44.0092 31.6127 43.8892 32.0827 43.6092L38.7227 39.7792C40.2127 38.9192 41.1327 37.3192 41.1327 35.5992V22.2992C41.1327 21.6892 40.6327 21.2092 40.0227 21.2292Z",
    fill: "url(#paint7_linear_4826_5164)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9977 26.45C36.3704 26.7246 36.45 27.2493 36.1753 27.622L30.3072 35.5854C30.0326 35.9581 29.5078 36.0376 29.1351 35.763C28.7624 35.4884 28.6829 34.9636 28.9575 34.5909L34.8256 26.6276C35.1002 26.2548 35.625 26.1753 35.9977 26.45Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.541429
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2267 35.6817C29.8993 36.0091 29.3685 36.0091 29.0411 35.6817L26.107 32.7479C25.7796 32.4205 25.7796 31.8898 26.107 31.5624C26.4343 31.235 26.9651 31.235 27.2925 31.5624L30.2266 34.4963C30.554 34.8236 30.554 35.3544 30.2267 35.6817Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.541429
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4826_5164",
    x: 1.68281,
    y: 3.6793,
    width: 60,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.05,
    dy: 3.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.73568 0 0 0 0 0.808576 0 0 0 0 0.860645 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4826_5164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4826_5164",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4826_5164",
    x1: 30.6328,
    y1: -18.4707,
    x2: 30.6328,
    y2: 76.1093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4826_5164",
    x1: 30.6328,
    y1: 17.6545,
    x2: 30.6328,
    y2: -58.3407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5787D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#004496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021E2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4826_5164",
    x1: 14.9429,
    y1: 17.8388,
    x2: 14.9429,
    y2: -0.231171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4826_5164",
    x1: 18.6343,
    y1: 17.8388,
    x2: 18.6343,
    y2: -0.231171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4826_5164",
    x1: 22.3237,
    y1: 17.8388,
    x2: 22.3237,
    y2: -0.231171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4826_5164",
    x1: 9.63086,
    y1: 71.8793,
    x2: 44.2809,
    y2: 33.5795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E5F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4826_5164",
    x1: 19.0828,
    y1: 32.5294,
    x2: 43.4078,
    y2: -16.1206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84AAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336ECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4826_5164",
    x1: 31.7244,
    y1: 40.9505,
    x2: 42.0253,
    y2: -1.29676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81A7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4826_5164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.632812 0.0292969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustIcon);
export default __webpack_public_path__ + "static/media/TrustIcon.a10915cbc67383c3c818fa660ab77197.svg";
export { ForwardRef as ReactComponent };